import {Component} from 'react';
import AddDeviceModal from "../modals/AddDeviceModal";
import "react-table/react-table.css";
import React from "react";
import DeleteDeviceConfirmModal from "../modals/DeleteDeviceConfirmModal";
import Badge from 'react-bootstrap/lib/Badge';
import AzureTable from "../AzureTable";
import LoadingModal from "../modals/LoadingModal";
import ReactTable from "react-table";
import Alert from "react-bootstrap/es/Alert";
import Chart from 'react-google-charts';
import VMSub from "../subcomponents/VMSub";
import QRCodeDialog from "../modals/QRCodeDialog";
import OverlayTrigger from "react-bootstrap/es/OverlayTrigger";
import Tooltip from "react-bootstrap/es/Tooltip";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Modal from "react-responsive-modal";
import request from "request-promise-native";
import FailedDialog from "../../utils/modals/FailedDialog";
import SuccessDialog from "../../utils/modals/SuccessDialog";

import QRCode from "qrcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Form from "react-bootstrap/lib/Form";
import Button from "react-bootstrap/lib/Button";
import DeviceScreen from "../screens/DeviceScreen";
import MoveDeviceModal from "../modals/MoveDeviceModal";
import GenerateReportModal from "../modals/GenerateReportModal";

window.html2canvas = html2canvas;

const GET_PROJECTS_URL = "https://qibipay.azurewebsites.net/api/VMList";
const WEB_APP_BASE_URL = "https://qrscanner.z19.web.core.windows.net/?regId=";
const VOUCHER_GEN_URL = "https://qibipay.azurewebsites.net/api/VoucherGenerate";
const DEVICE_REPORT_GEN_URL = "https://qibipay.azurewebsites.net/api/GetAdminReport";

const qrBadge = "\n" +
    "\t\t<div class=\"_idGenObjectLayout-2\">\n" +
    "\t\t\t\t<img class=\"_idGenObjectAttribute-1\" src=\"images/beizin.png\" alt=\"\" />\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div id=\"_idContainer002\" class=\"Einfacher-Textrahmen\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-1\">Voucher</span></p>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div class=\"_idGenObjectLayout-1\">\n" +
    "\t\t\t<div id=\"_idContainer001\" class=\"_idGenObjectStyleOverride-1\">\n" +
    "\t\t\t\t<img class=\"_idGenObjectAttribute-2\" src=\"%qrSrc%\" alt=\"\" />\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div id=\"_idContainer003\" class=\"Einfacher-Textrahmen\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-2\">%resName%</span></p>\n" +
    "\t\t</div>\n" +
    "\t\t<div id=\"_idContainer004\" class=\"Einfacher-Textrahmen _idGenObjectStyleOverride-2\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-3\">%tableName%</span></p>\n" +
    "\t\t</div>";

class DevicesTab extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - logout
             - devices
             - onDeviceRemove
             - onDeviceAdd
             - currency
        */
        super(props);

        this.state = {
            deviceOpen: null,

            addDeviceOpen: false,
            editDevice: null,

            deleteDeviceOpen: false,
            deleteDevice: null,

            loading: true,

            qrCodeDisplayed: null,
            qrCodeDisplayName: null
        };

    }

    async vouchersDownloadPdf() {
        let pdf = new jsPDF('l', 'mm', 'a4');

        const vouchers = this.state.vouchers;

        const element = document.createElement("div");
        element.classList.add("_idGenObjectLayout-3");
        document.getElementById("root").appendChild(element);

        for(let i=0;i<vouchers.length;i++) {
            const dataUrl = await new Promise(function(resolve, reject) {
                QRCode.toDataURL(vouchers[i], {
                    margin: 0
                }, function (err, generated) {
                    if(err) {
                        reject(err);
                        return;
                    }
                    resolve(generated);
                })
            });

            element.innerHTML = qrBadge
                .replace(new RegExp("%qrSrc%", 'g'), dataUrl)
                .replace(new RegExp("%resName%", 'g'), this.state.vouchersDevice.name)
                .replace(new RegExp("%tableName%", 'g'), this.state.vouchersItemNum);

            const canvas = await html2canvas(element, {scale: 3});

            console.log(canvas.width);
            console.log(canvas.height);

            pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 21.5+(50.8*(i%5)), 70*(Math.floor(i/5)%3), 50.8, 70);

            if(i%15===14) {
                pdf.addPage();
                pdf.setFontSize(9);
            }
        }

        document.getElementById("root").removeChild(element);

        pdf.save(this.state.vouchersDevice.name+"-"+this.state.vouchersItemNum+"-"+new Date().toISOString().replace(new RegExp(":",'g'), "-")+".pdf");
    }

    async vouchersDownloadTxt() {
        const element = document.createElement('a');

        let text = "";

        for(let i=0;i<this.state.vouchers.length;i++) {
            text = text+this.state.vouchers[i]+"\n";
        }

        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', this.state.vouchersDevice.name+"-"+this.state.vouchersItemNum+"-"+new Date().toISOString().replace(new RegExp(":",'g'), "-")+".txt");

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    async generateVoucher(device, itemNumber, amount) {
        this.setState({
            generateDeviceOpen: false,
            generateDevice: null,
            voucherGenerating: true
        });

        const options = {
            method: 'POST',
            uri: VOUCHER_GEN_URL,
            body: {
                access_code: this.props.access_code,
                regId: device.regId,
                itemNum: itemNumber,
                amount
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!==200)  {
            if(response.statusCode===500) {
                this.setState({
                    voucherGenerating: false,
                    voucherError: "Internal server error"
                });
            } else {
                this.setState({
                    voucherGenerating: false,
                    voucherError: response.body
                });
            }
            return;
        }

        this.setState({
            vouchersItemNum: itemNumber,
            vouchersDevice: device,
            vouchers: response.body.voucher,
            voucherGenerating: false,
            voucherSuccess: "Vouchers ready!"
        });

    }

    async getDevicesReport() {
        this.setState({
            deviceReportError: null,
            deviceReportGenerating: true
        });

        const options = {
            method: 'POST',
            uri: DEVICE_REPORT_GEN_URL,
            body: {
                access_code: this.props.access_code
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!==200)  {
            if(response.statusCode===500) {
                this.setState({
                    deviceReportGenerating: false,
                    deviceReportError: "Internal server error"
                });
            } else {
                this.setState({
                    deviceReportGenerating: false,
                    deviceReportError: response.body
                });
            }
            return;
        }

        const csvHeader = ["\"Username\"", "\"Active device count\""].join(",")+"\n";
        const csvData = response.body.data
            .map(e => ["\""+e.username+"\"", "\""+e.count+"\""].join(",")).join("\n");

        const resultString = csvHeader+csvData;

        const url = window.URL.createObjectURL(new Blob([resultString], {
            type: 'text/csv'
        }));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = "deviceReport-"+Date.now()+".csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.setState({
            deviceReportGenerating: false,
        });

    }

    render() {

        const addDeviceModal = this.state.addDeviceOpen ? (<AddDeviceModal
            access_code={this.props.access_code}
            open={true}
            onClose={() => this.setState({addDeviceOpen: false})}
            device={this.state.editDevice}
            logout={this.props.logout}
            tableRef={this.tableRef}
            admin={this.props.admin}
            onSave={(dev) => {
                if(this.state.deviceOpen!=null) this.setState({
                    deviceOpen: dev
                });
            }
            }/>) : '';

        if(this.state.deviceOpen!=null) {
            return (
                <>
                    {addDeviceModal}
                    <DeviceScreen
                        admin={this.props.admin}
                        onDeviceReboot={() => {
                            const deviceCpy = {...this.state.deviceOpen};
                            deviceCpy.config = "reboot";
                            this.setState({
                                deviceOpen: deviceCpy
                            });
                        }}
                        access_code={this.props.access_code}
                        logout={this.props.logout}
                        device={this.state.deviceOpen}
                        onClose={() => {
                            this.setState({
                                deviceOpen: null
                            });
                        }}
                        openConfig={() => {
                            this.setState({
                                addDeviceOpen: true,
                                editDevice: this.state.deviceOpen
                            });
                        }}
                    />
                </>
            )
        }

        const columns = [
            {
                Header: "Status",
                accessor: "status",
                width: 50,
                sortable: false,
                filterable: true,
                FilterOptions: [
                    {
                        display_name: "All",
                        value: ""
                    },
                    {
                        display_name: "Online",
                        value: "online"
                    },
                    {
                        display_name: "Offline",
                        value: "offline"
                    }
                ],
                Cell: (row) => {
                    return (
                        <>
                            {row.original.status==="Offline" ? (
                                <OverlayTrigger
                                    key={"tooltipname-"+row.original.regId}
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltipname-`+row.original.regId}>
                                            Offline<br/>
                                            Last contact: {row.original.lastSetStatus==null ? "Never" : new Date(row.original.lastSetStatus).toLocaleString()}
                                        </Tooltip>
                                    }
                                >
                                    <a style={{
                                        color: "red"
                                    }}>
                                        <i className="mdi mdi-brightness-1"/>
                                    </a>
                                </OverlayTrigger>
                            ) : (
                                <OverlayTrigger
                                    key={"tooltipname-"+row.original.regId}
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltipname-`+row.original.regId}>
                                            {row.original.status} (Online)<br/>
                                            {row.original.config==="sync" ? "Config synced" : "Awaiting config sync..."}<br/>
                                            Last contact: {row.original.lastSetStatus==null ? "Never" : new Date(row.original.lastSetStatus).toLocaleString()}
                                        </Tooltip>
                                    }
                                >
                                    <a style={{
                                        color: row.original.config==="sync" ? "green" : "orange"
                                    }}>
                                        <i className="mdi mdi-brightness-1"/>
                                    </a>
                                </OverlayTrigger>
                            )}
                            {(row.original.type==="twintqr" || row.original.type==="contact") && row.original.mqttConnected!==undefined ? (
                                <OverlayTrigger
                                    key={"tooltiptwint-"+row.original.regId}
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltipname-`+row.original.regId}>
                                            {row.original.mqttConnected ? "Online (Payment server connected)" : "Offline (Payment server disconnected)"}
                                        </Tooltip>
                                    }
                                >
                                    <a style={{
                                        color: row.original.mqttConnected ? "green" : "red"
                                    }}>
                                        <i className="mdi mdi-brightness-1"/>
                                    </a>
                                </OverlayTrigger>
                            ) : ""}
                        </>
                    )
                }
            },
            {
                Header: "Name",
                accessor: "name",
                filterable: true,
                width: 175
            },
            {
                Header: "Registration ID",
                accessor: "regId",
                filterable: true,
                width: 200,
                Cell: row => {
                    if(row.original.regId.startsWith("&")) {
                        //Android
                        return (<div><i className="fa fa-tablet-alt" /><a style={{
                            marginLeft: "8px"
                        }}>{row.original.regId}</a><OverlayTrigger
                            key={"tooltip"+row.original.regId}
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-`+row.original.regId}>
                                    Shows QR code that you can scan with your mobile device
                                </Tooltip>
                            }
                        >
                            <a style={{
                                marginLeft: "8px"
                            }} href="javascript:void(0);" onClick={() => {
                                this.setState({
                                    qrCodeDisplayed: row.original.regId
                                });
                            }}><i className="fa fa-qrcode"/></a>
                        </OverlayTrigger>
                        </div>);
                    }

                    return (<div><i className="fa fa-microchip" /><a style={{
                        marginLeft: "8px"
                    }}>{row.original.regId}</a><OverlayTrigger
                        key={"tooltip"+row.original.regId}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-`+row.original.regId}>
                                Machine QR code for webapp payments
                            </Tooltip>
                        }
                    >
                        <a style={{
                            marginLeft: "8px"
                        }} href="javascript:void(0);" onClick={() => {
                            this.setState({
                                qrCodeDisplayed: WEB_APP_BASE_URL+encodeURIComponent(row.original.regId),
                                qrCodeDisplayName: "Web app code for "+row.original.name
                            });
                        }}><i className="fa fa-camera"/></a>
                    </OverlayTrigger></div>);
                }
            },
            {
                Header: "Description",
                accessor: "description",
                filterable: false,
                sortable: false
            },
            {
                Header: "Interval",
                accessor: "interval",
                filterable: false,
                Cell: row => row.original.interval + (row.original.interval===1 ? ' hour' : ' hours'),
                sortable: false,
                maxWidth: 110
            },
            {
                Header: "Type",
                accessor: "usemdb",
                filterable: true,
                FilterOptions: [
                    {
                        display_name: "All",
                        value: ""
                    },
                    {
                        display_name: "MDB Cashless",
                        value: "mdb"
                    },
                    {
                        display_name: "Vimasim",
                        value: "vimasim"
                    },
                    {
                        display_name: "Twint Beacon",
                        value: "twint"
                    },
                    {
                        display_name: "Twint QR",
                        value: "twintqr"
                    },
                    {
                        display_name: "Telemetry",
                        value: "tele"
                    },
                    {
                        display_name: "Contact Closure",
                        value: "contact"
                    },
                ],
                Cell: row => row.original.vimasim ? (
                    <Badge>Vimasim</Badge>
                ) : row.original.type==="tele" ? (
                    <Badge>Telemetry</Badge>
                ) : row.original.type==="twint" ? (
                    <Badge>Twint Beacon</Badge>
                ) : row.original.type==="twintqr" ? (
                    <Badge>Twint QR</Badge>
                ) : row.original.type==="contact" ? (
                    <Badge>Contact Closure</Badge>
                ) : row.original.usemdb ? (
                    <Badge>MDB Cashless</Badge>
                ) : (
                    <div><Badge>Relay (Default price: {row.original.defaultPrice==null ? "0.00" : parseInt(row.original.defaultPrice).toFixed(2)})</Badge></div>
                ),
                sortable: false
            },
            {
                Header: "Monthly Revenue",
                accessor: "revenues",
                filterable: false,
                Cell: row => row.original.revenues!=null && row.original.revenues.currentTotal!==null && row.original.revenues.currentTotal!==undefined ? (<Badge>+{row.original.revenues.currentTotal.toFixed(2)} {this.props.currency}</Badge>) : (<Badge>0.00 {this.props.currency}</Badge>),
                sortable: false,
                width: 100
            },
            {
                Header: "Monthly Revalue",
                accessor: "revalues",
                filterable: false,
                Cell: row => row.original.revalues!=null && row.original.revalues.currentTotal!==null && row.original.revalues.currentTotal!==undefined ? (<Badge>+{row.original.revalues.currentTotal.toFixed(2)} {this.props.currency}</Badge>) : (<Badge>0.00 {this.props.currency}</Badge>),
                sortable: false,
                width: 100
            }
        ];

        if(this.props.admin) {
            columns.push({
                Header: "Username",
                accessor: "username",
                sortable: false,
                filterable: true,
                width: 100
            });
        }

        columns.push({
            Header: "",
            Cell: row => (
                <>
                    <a href="javascript:void(0);" onClick={() => {
                        this.setState({
                            deleteDeviceOpen:true,
                            deleteDevice: row.original
                        })
                        console.log(row.original);
                    }}><i className="fa fa-trash"></i></a>
                    {row.original.username!=null ? (
                        <> |<a href="javascript:void(0);" className="ml-2" onClick={() => {
                            this.setState({
                                moveDevice: row.original
                            })
                            console.log(row.original);
                        }}><i className="fa fa-exchange-alt"></i></a>
                        </>
                    ) : ""}
                    {row.original.type==="contact" ? (
                        <> |<a href="javascript:void(0);" className="ml-2" onClick={() => {
                            this.setState({
                                generateDeviceOpen: true,
                                generateDevice: row.original
                            })
                            console.log(row.original);
                        }}><i className="fa fa-credit-card"></i></a>
                        </>
                    ) : ""}
                </>
            ),
            maxWidth: 96,
            sortable: false,
            filterable: false
        });

        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-book"></i> Vending machines <a href="javascript:void(0);" style={{
                                fontSize: "15px"
                            }} onClick={() => {
                                this.tableRef.resetTable();
                            }}><i className="fa fa-sync"></i></a></h3>
                            <div className="ml-auto text-right">
                                {this.props.admin ? (
                                    <button className="btn btn-success mr-3" onClick = {this.getDevicesReport.bind(this)}>
                                        <i className="mdi mdi-counter font-16"></i>Device report
                                    </button>
                                ) : ""}
                                <button className="btn btn-warning mr-3" onClick = {() => this.setState({generateReport: true})}>
                                    <i className="mdi mdi-receipt font-16"></i>Sales report
                                </button>
                                <button className="btn btn-primary" onClick = {() => this.setState({addDeviceOpen: true, editDevice: null})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Device
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <GenerateReportModal
                    access_code={this.props.access_code}
                    open={this.state.generateReport}
                    onClose={() => {
                        this.setState({
                            generateReport: false
                        })
                    }}
                    logout={this.props.logout}
                />

                <Modal open={this.state.generateDeviceOpen} onClose={() => {
                    this.setState({
                        generateDeviceOpen: false,
                        generateDevice: null
                    });
                }} styles={{
                    modal: {
                        minWidth: '200px',
                        width: this.props.width ? this.props.width+"px" : '400px'
                    }
                }} >
                    <h2>Generate voucher</h2>

                    <h4 className="my-4">{this.state.generateDevice==null ? "" : this.state.generateDevice.name}</h4>

                    <label>How many?</label>
                    <ValidatedFormComponent
                                            type="number"
                                            defaultValue={1}
                                            min={1}
                                            max={100}
                                            onValidate={input => {
                                                return null;
                                            }}
                                            inputRef={ref => this.amountRef=ref}
                    />

                    <br/>
                    <br/>

                    <ReactTable
                        getTdProps={(state, rowInfo, column, instance) => {
                            return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    if(!this.amountRef.validated()) return;
                                    this.generateVoucher(this.state.generateDevice, rowInfo.original.id, parseInt(this.amountRef.value));
                                }
                            };
                            return {};
                        }}
                        data={(()=>{
                            if(this.state.generateDevice==null) return [];
                            const arr = [];
                            for(let i = 1;i<16;i++) {
                                const e = i;
                                if(i<10) {
                                    i = "0"+i;
                                }
                                arr.push({
                                    id: e,
                                    level: "Product "+e,
                                    price: this.state.generateDevice.configuration["price"+i].toFixed(2)
                                });
                            }
                            return arr;
                        })()}
                        columns={[
                            {
                                Header: "Product",
                                accessor: "level",

                            },
                            {
                                Header: "Price",
                                accessor: "price",
                            }
                        ]}
                        showPagination={false}
                        sortable={false}
                        className="-striped -highlight"
                        pageSize={15}
                    />

                </Modal>

                <QRCodeDialog
                    open={this.state.qrCodeDisplayed!=null}
                    onClose={()=>{
                        this.setState({
                            qrCodeDisplayed: null,
                            qrCodeDisplayName: null
                        });
                    }}
                    title={this.state.qrCodeDisplayName==null ? this.state.qrCodeDisplayed : this.state.qrCodeDisplayName}
                    enableDownload={this.state.qrCodeDisplayName!=null}
                    qrCode={this.state.qrCodeDisplayed}
                />

                <LoadingModal title="Generating..."
                              text="Generating a new voucher..."
                              open={this.state.voucherGenerating}/>

                <FailedDialog open={this.state.voucherError}
                              title="Generation failed"
                              text={this.state.voucherError}
                                onClose={() => {
                                    this.setState({
                                        voucherError: null
                                    });
                                }}/>

                <LoadingModal title="Generating..."
                              text="Generating device report..."
                              open={this.state.deviceReportGenerating}/>

                <FailedDialog open={this.state.deviceReportError}
                              title="Device report failed"
                              text={this.state.deviceReportError}
                              onClose={() => {
                                  this.setState({
                                      deviceReportError: null
                                  });
                              }}/>


                <Modal open={this.state.voucherSuccess} onClose={() => {
                    this.setState({
                        voucherSuccess: null
                    });
                }} styles={{
                    modal: {
                        minWidth: '200px',
                        width: '400px'
                    }
                }} >
                    <h2><i className="fa fa-check-circle text-success"/> {"Voucher generated"}</h2>
                    <p>{this.state.voucherSuccess}</p>
                    <Button bsStyle="success" onClick={this.vouchersDownloadPdf.bind(this)}>
                        Download PDF
                    </Button>
                    <Button className="ml-3" bsStyle="success" onClick={this.vouchersDownloadTxt.bind(this)}>
                        Download TXT
                    </Button>
                </Modal>

                <LoadingModal title="Loading..."
                                text="Loading user devices..."
                                open={this.state.loading}/>

                <DeleteDeviceConfirmModal access_code={this.props.access_code}
                                           device={this.state.deleteDevice}
                                           open={this.state.deleteDeviceOpen}
                                           onClose={() => this.setState({
                                               deleteDeviceOpen: false,
                                               deleteDevice: null
                                           })}
                                           onDeviceRemove={() => {
                                               this.tableRef.resetTable();
                                           }}
                                           logout={this.props.logout}/>

                <MoveDeviceModal access_code={this.props.access_code}
                                          device={this.state.moveDevice}
                                          open={this.state.moveDevice!=null}
                                          onClose={() => this.setState({
                                              moveDevice: null
                                          })}
                                          onDeviceMoved={() => {
                                              this.tableRef.resetTable();
                                          }}
                                          logout={this.props.logout}/>

                {addDeviceModal}

                <div className="container-fluid">
                    <AzureTable
                                SubComponent={(row) => {

                                    let part = null;

                                    const data = [];

                                    if(row.original.DeviceInfo!=null) for(let field in row.original.DeviceInfo) {
                                        data.push({
                                            name: field,
                                            value: row.original.DeviceInfo[field]
                                        })
                                    }

                                    if(data.length===0) {
                                        part =  (
                                                <Alert bsStyle="warning">
                                                    <strong>Device info not yet available!</strong> This can be caused by using older version of Flexa firmware or by the fact that the device hasn't yet contacted QIBaccount service
                                                </Alert>
                                        );
                                    } else {
                                        part = (
                                            <ReactTable
                                                showPagination={false}
                                                sortable={false}
                                                filterable={false}
                                                pageSize={data.length}
                                                data={data}
                                                columns={[
                                                    {
                                                        Header:"Device information",
                                                        accessor: "name",
                                                        maxWidth: 300,
                                                    },
                                                    {
                                                        accessor: "value"
                                                    }
                                                ]}
                                            />
                                        );
                                    }

                                    if(row.original.revenues==null && row.original.revenue) {

                                    }


                                    return (
                                          <div className="mx-4 my-4">
                                              {part==null ? "" : part}

                                              <VMSub
                                                    revalues={row.original.revalues}
                                                    revenues={row.original.revenues}
                                                    currency={this.props.currency}
                                              />
                                          </div>
                                    );

                                }}
                                getTdProps={(state, rowInfo, column, instance) => {
                                    if(rowInfo!=null && column.Header!=='Delete' && column.Header!=='Registration ID' && column.Header!=="" && column.Header!=null) return {
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        onClick: e => {
                                            console.log("Cell - onClick", rowInfo.original);
                                            this.setState({
                                                deviceOpen: rowInfo.original
                                            });
                                        }
                                    };
                                    return {};
                                }}
                                logout={this.props.logout}
                                access_code={this.props.access_code}
                                onLoad={() => {
                                    this.setState({
                                        loading: false
                                    });
                                }}
                                tableRef={(ref) => {
                                    this.tableRef = ref;
                                }}
                                functionUrl={GET_PROJECTS_URL}
                                defaultSorted={[
                                    {
                                        id: "regId",
                                        desc: false
                                    }
                                ]}
                                columns={columns}
                                filterable
                                defaultPageSize={10}
                                className="-striped -highlight"
                                pageSize={10}
                    />
                </div>
            </div>
        );
    }
}

export default DevicesTab;